import { GetAuthTokenResponse } from 'application-types';
import { request, Res } from './common';

export interface ListParams {
  building_id: string;
}

export type ListResData = Floor[];

export interface Floor {
  id: string;
  name: string;
}

export async function list(
  token: string,
  params: ListParams,
  options?: {
    getAuthToken?: GetAuthTokenResponse,
    enableTokenManagement?: boolean,
    channelIntegrationId?: string
  }
): Promise<Res<ListResData>> {
  return request({
    token,
    method: 'get',
    path: `/buildings/${params.building_id}/floors`,
    getAuthToken: options?.getAuthToken,
    enableTokenManagement: options?.enableTokenManagement,
    channelIntegrationId: options?.channelIntegrationId,
  });
}
